function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  r: 256
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M195.743,221.661c-5.217,5.252-5.853,13.515-1.501,19.509c10.24,14.08,21.575,27.33,33.898,39.636 c13.753,13.798,28.698,26.35,44.668,37.517c5.994,4.202,14.151,3.496,19.332-1.677l28.425-28.425c7.821-7.821,20.515-7.821,28.337,0 l49.611,49.611c7.821,7.821,7.821,20.515,0,28.337l-13.418,13.418c-19.553,19.756-48.004,27.86-75.034,21.363 c-25.079-6.647-48.922-17.293-70.621-31.514c-19.977-12.659-38.506-27.454-55.261-44.138c-15.404-15.325-29.246-32.15-41.313-50.229 c-13.277-19.562-23.79-40.863-31.25-63.294c-9.172-28.593-1.571-59.913,19.686-81.126l15.625-15.89 c7.821-7.821,20.515-7.821,28.337,0l49.611,49.611c7.821,7.821,7.821,20.515,0,28.337L195.743,221.661z"
});

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.eff830f4.svg";
export { ForwardRef as ReactComponent };